export const mapVideoOutput = resolution => {
  const urlRegex = /video\/.*.mp4*/;
  const url = resolution.url || '';
  const urlMatch = url.match(urlRegex);
  return {
    kind: undefined,
    url: urlMatch ? urlMatch[0] : undefined,
    audio_bitrate: -1,
    display_aspect_ratio: '',
    duration: resolution.durationInMilliseconds || 0,
    format: resolution.format || '',
    fps: '',
    height: resolution.height || 0,
    key: resolution.assetKey || '',
    quality: resolution.quality || undefined,
    secure: Boolean(resolution.private),
    status: 'READY',
    tag: '',
    video_bitrate: -1,
    width: resolution.width || 0
  };
};
export const mapImageOutput = image => {
  const formatRegex = /\.(\w+)$/;
  const urlRegex = /media\/(.*)\.jpg$/;
  const url = image.url || '';
  const urlMatch = url.match(urlRegex);
  const formatMatch = url.match(formatRegex);
  return {
    format: formatMatch ? formatMatch[1] : '',
    height: image.height || 0,
    secure: false,
    status: 'READY',
    url: urlMatch ? urlMatch[0] : '',
    width: image.height || 0
  };
};
const mapVideoFileOutput = file => {
  var _file$media, _file$media2;
  const hlsUrlRegex = /site\/media\/video.*/;
  const posters = ((_file$media = file.media) == null || (_file$media = _file$media.video) == null ? void 0 : _file$media.posters) || [];
  const resolutions = ((_file$media2 = file.media) == null || (_file$media2 = _file$media2.video) == null ? void 0 : _file$media2.resolutions) || [];
  const images = posters.map(mapImageOutput);
  const videos = [];
  const storyboards = [];
  const adaptiveVideos = [];
  const clips = [];
  const trailers = [];
  for (const resolution of resolutions) {
    if (resolution.format === 'hls') {
      const url = resolution.url || '';
      const match = url.match(hlsUrlRegex);
      adaptiveVideos.push({
        format: resolution.format,
        key: resolution.assetKey || '',
        status: 'READY',
        tag: '',
        url: match ? match[0] : ''
      });
      continue;
    }
    const videoOutput = mapVideoOutput(resolution);
    const assetKey = resolution.assetKey || '';
    if (assetKey.startsWith('storyboard-')) {
      storyboards.push(videoOutput);
      continue;
    }
    if (assetKey.startsWith('clip-')) {
      clips.push(videoOutput);
      continue;
    }
    if (assetKey.startsWith('trailer-')) {
      trailers.push(videoOutput);
      continue;
    }
    videos.push(videoOutput);
  }
  return {
    image: images,
    video: videos,
    storyboard: storyboards,
    adaptive_video: adaptiveVideos,
    clip: clips,
    trailer: trailers
  };
};
const mapVideoFileInput = file => {
  const media = file.media;
  const video = media == null ? void 0 : media.video;
  const poster = video != null && video.posters ? video.posters[0] : null;
  return {
    audio_bitrate: 0,
    display_aspect_ratio: '',
    duration: (video == null ? void 0 : video.durationInMilliseconds) || 0,
    fps: '',
    height: (poster == null ? void 0 : poster.height) || 0,
    rotation: 0,
    sample_aspect_ratio: '',
    type: 'video',
    video_bitrate: 0,
    width: (poster == null ? void 0 : poster.width) || 0
  };
};
export const mapBaseVideo = (file, baseFile) => {
  return {
    ...baseFile,
    fileInput: mapVideoFileInput(file),
    fileOutput: mapVideoFileOutput(file)
  };
};
//# sourceMappingURL=BaseVideo.mappers.js.map